var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAgreeFalse({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18ZM7.70711 13.7071L15.2071 6.20711L13.7929 4.79289L7 11.5858L4.20711 8.79289L2.79289 10.2071L6.29289 13.7071L7 14.4142L7.70711 13.7071Z",
    fill: "#E8E8E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAgreeFalse);
export default __webpack_public_path__ + "static/media/icon-agree-false.5cb9d0f39e5e03d697603155a27db6ee.svg";
export { ForwardRef as ReactComponent };